/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult2,
  IntermediaryClientPlanDetailsRequest,
  InternalRateOfReturnPeriod,
  NotFoundErrorResult2,
  ResultOfBeneficiariesViewModel,
  ResultOfClientBankAccountsViewModel,
  ResultOfClientInvestmentInfoViewModel,
  ResultOfClientPersonalDetailsViewModel,
  ResultOfIntermediaryDetailsViewModel,
  ResultOfInternalRateOfReturnViewModel,
  ResultOfListOfIntermediaryClientPlanDetail,
  ResultOfPortfolioSummaryViewModel,
  StatementOptions,
  ValidationErrorResult2,
} from '../models';
import {
    ErrorResult2FromJSON,
    ErrorResult2ToJSON,
    IntermediaryClientPlanDetailsRequestFromJSON,
    IntermediaryClientPlanDetailsRequestToJSON,
    InternalRateOfReturnPeriodFromJSON,
    InternalRateOfReturnPeriodToJSON,
    NotFoundErrorResult2FromJSON,
    NotFoundErrorResult2ToJSON,
    ResultOfBeneficiariesViewModelFromJSON,
    ResultOfBeneficiariesViewModelToJSON,
    ResultOfClientBankAccountsViewModelFromJSON,
    ResultOfClientBankAccountsViewModelToJSON,
    ResultOfClientInvestmentInfoViewModelFromJSON,
    ResultOfClientInvestmentInfoViewModelToJSON,
    ResultOfClientPersonalDetailsViewModelFromJSON,
    ResultOfClientPersonalDetailsViewModelToJSON,
    ResultOfIntermediaryDetailsViewModelFromJSON,
    ResultOfIntermediaryDetailsViewModelToJSON,
    ResultOfInternalRateOfReturnViewModelFromJSON,
    ResultOfInternalRateOfReturnViewModelToJSON,
    ResultOfListOfIntermediaryClientPlanDetailFromJSON,
    ResultOfListOfIntermediaryClientPlanDetailToJSON,
    ResultOfPortfolioSummaryViewModelFromJSON,
    ResultOfPortfolioSummaryViewModelToJSON,
    StatementOptionsFromJSON,
    StatementOptionsToJSON,
    ValidationErrorResult2FromJSON,
    ValidationErrorResult2ToJSON,
} from '../models';

export interface ClientDetailsGetBeneficiariesRequest {
    clientId?: number;
}

export interface ClientDetailsGetClientBankAccountsRequest {
    clientId?: number;
}

export interface ClientDetailsGetClientInvestmentInfoRequest {
    clientId?: string | null;
}

export interface ClientDetailsGetClientPersonalDetailsRequest {
    clientId: string;
}

export interface ClientDetailsGetExcelStatementDownloadRequest {
    clientId?: string | null;
    planNumber?: Array<string> | null;
    statementType?: ClientDetailsGetExcelStatementDownloadStatementTypeEnum;
    dateRangeItem1?: Date;
    dateRangeItem2?: Date;
    startDate?: Date | null;
    endDate?: Date | null;
    internalRateOfReturnPeriods?: Array<InternalRateOfReturnPeriod> | null;
    statementOptions?: Array<StatementOptions> | null;
}

export interface ClientDetailsGetIRRSummaryStatementRequest {
    clientId?: string | null;
    investmentPlanNumbers?: Array<number> | null;
    compiledBy?: string | null;
    customPeriod?: boolean;
    startDate?: Date;
    endDate?: Date;
    standardPeriods?: Array<string> | null;
}

export interface ClientDetailsGetIntermediaryDetailsRequest {
    clientId?: string | null;
}

export interface ClientDetailsGetPdfStatementDownloadRequest {
    clientId?: string | null;
    planNumber?: Array<string> | null;
    statementType?: ClientDetailsGetPdfStatementDownloadStatementTypeEnum;
    dateRangeItem1?: Date;
    dateRangeItem2?: Date;
    startDate?: Date | null;
    endDate?: Date | null;
    internalRateOfReturnPeriods?: Array<InternalRateOfReturnPeriod> | null;
    statementOptions?: Array<StatementOptions> | null;
}

export interface ClientDetailsGetPortfolioSummaryRequest {
    clientId?: string | null;
    effectiveDate?: Date | null;
    includeAll?: boolean | null;
}

export interface ClientDetailsSearchClientPlanDetailsRequest {
    request: IntermediaryClientPlanDetailsRequest;
}

/**
 * 
 */
export class ClientDetailsApi extends runtime.BaseAPI {

    /**
     * Get Beneficiaries
     */
    async clientDetailsGetBeneficiariesRaw(requestParameters: ClientDetailsGetBeneficiariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfBeneficiariesViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/1.0/reporting/beneficiaries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfBeneficiariesViewModelFromJSON(jsonValue));
    }

    /**
     * Get Beneficiaries
     */
    async clientDetailsGetBeneficiaries(requestParameters: ClientDetailsGetBeneficiariesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfBeneficiariesViewModel> {
        const response = await this.clientDetailsGetBeneficiariesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of bank accounts for client
     */
    async clientDetailsGetClientBankAccountsRaw(requestParameters: ClientDetailsGetClientBankAccountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfClientBankAccountsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/1.0/reporting/bank-accounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfClientBankAccountsViewModelFromJSON(jsonValue));
    }

    /**
     * Get list of bank accounts for client
     */
    async clientDetailsGetClientBankAccounts(requestParameters: ClientDetailsGetClientBankAccountsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfClientBankAccountsViewModel> {
        const response = await this.clientDetailsGetClientBankAccountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a quick view of a client\'s investments to enable querying for statements
     */
    async clientDetailsGetClientInvestmentInfoRaw(requestParameters: ClientDetailsGetClientInvestmentInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfClientInvestmentInfoViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/1.0/reporting/client-investments-info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfClientInvestmentInfoViewModelFromJSON(jsonValue));
    }

    /**
     * Get a quick view of a client\'s investments to enable querying for statements
     */
    async clientDetailsGetClientInvestmentInfo(requestParameters: ClientDetailsGetClientInvestmentInfoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfClientInvestmentInfoViewModel> {
        const response = await this.clientDetailsGetClientInvestmentInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get client details
     */
    async clientDetailsGetClientPersonalDetailsRaw(requestParameters: ClientDetailsGetClientPersonalDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfClientPersonalDetailsViewModel>> {
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId','Required parameter requestParameters.clientId was null or undefined when calling clientDetailsGetClientPersonalDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/1.0/reporting/client-personal-details/{clientId}`.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfClientPersonalDetailsViewModelFromJSON(jsonValue));
    }

    /**
     * Get client details
     */
    async clientDetailsGetClientPersonalDetails(requestParameters: ClientDetailsGetClientPersonalDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfClientPersonalDetailsViewModel> {
        const response = await this.clientDetailsGetClientPersonalDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download a xlsx file for a specified report
     */
    async clientDetailsGetExcelStatementDownloadRaw(requestParameters: ClientDetailsGetExcelStatementDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['ClientId'] = requestParameters.clientId;
        }

        if (requestParameters.planNumber) {
            queryParameters['PlanNumber'] = requestParameters.planNumber;
        }

        if (requestParameters.statementType !== undefined) {
            queryParameters['StatementType'] = requestParameters.statementType;
        }

        if (requestParameters.dateRangeItem1 !== undefined) {
            queryParameters['DateRange.Item1'] = (requestParameters.dateRangeItem1 as any).toISOString();
        }

        if (requestParameters.dateRangeItem2 !== undefined) {
            queryParameters['DateRange.Item2'] = (requestParameters.dateRangeItem2 as any).toISOString();
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['StartDate'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['EndDate'] = (requestParameters.endDate as any).toISOString();
        }

        if (requestParameters.internalRateOfReturnPeriods) {
            queryParameters['InternalRateOfReturnPeriods'] = requestParameters.internalRateOfReturnPeriods;
        }

        if (requestParameters.statementOptions) {
            queryParameters['StatementOptions'] = requestParameters.statementOptions;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/1.0/reporting/download-excel-statement`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download a xlsx file for a specified report
     */
    async clientDetailsGetExcelStatementDownload(requestParameters: ClientDetailsGetExcelStatementDownloadRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.clientDetailsGetExcelStatementDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a summary of the Internal Rate of Returns of specified investments
     */
    async clientDetailsGetIRRSummaryStatementRaw(requestParameters: ClientDetailsGetIRRSummaryStatementRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfInternalRateOfReturnViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        if (requestParameters.investmentPlanNumbers) {
            queryParameters['investmentPlanNumbers'] = requestParameters.investmentPlanNumbers;
        }

        if (requestParameters.compiledBy !== undefined) {
            queryParameters['compiledBy'] = requestParameters.compiledBy;
        }

        if (requestParameters.customPeriod !== undefined) {
            queryParameters['customPeriod'] = requestParameters.customPeriod;
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = (requestParameters.endDate as any).toISOString();
        }

        if (requestParameters.standardPeriods) {
            queryParameters['standardPeriods'] = requestParameters.standardPeriods;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/1.0/reporting/statements-info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfInternalRateOfReturnViewModelFromJSON(jsonValue));
    }

    /**
     * Get a summary of the Internal Rate of Returns of specified investments
     */
    async clientDetailsGetIRRSummaryStatement(requestParameters: ClientDetailsGetIRRSummaryStatementRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfInternalRateOfReturnViewModel> {
        const response = await this.clientDetailsGetIRRSummaryStatementRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async clientDetailsGetIntermediaryDetailsRaw(requestParameters: ClientDetailsGetIntermediaryDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfIntermediaryDetailsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/1.0/reporting/intermediary-details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfIntermediaryDetailsViewModelFromJSON(jsonValue));
    }

    /**
     */
    async clientDetailsGetIntermediaryDetails(requestParameters: ClientDetailsGetIntermediaryDetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfIntermediaryDetailsViewModel> {
        const response = await this.clientDetailsGetIntermediaryDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download a PDF for a specified report
     */
    async clientDetailsGetPdfStatementDownloadRaw(requestParameters: ClientDetailsGetPdfStatementDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['ClientId'] = requestParameters.clientId;
        }

        if (requestParameters.planNumber) {
            queryParameters['PlanNumber'] = requestParameters.planNumber;
        }

        if (requestParameters.statementType !== undefined) {
            queryParameters['StatementType'] = requestParameters.statementType;
        }

        if (requestParameters.dateRangeItem1 !== undefined) {
            queryParameters['DateRange.Item1'] = (requestParameters.dateRangeItem1 as any).toISOString();
        }

        if (requestParameters.dateRangeItem2 !== undefined) {
            queryParameters['DateRange.Item2'] = (requestParameters.dateRangeItem2 as any).toISOString();
        }

        if (requestParameters.startDate !== undefined) {
            queryParameters['StartDate'] = (requestParameters.startDate as any).toISOString();
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['EndDate'] = (requestParameters.endDate as any).toISOString();
        }

        if (requestParameters.internalRateOfReturnPeriods) {
            queryParameters['InternalRateOfReturnPeriods'] = requestParameters.internalRateOfReturnPeriods;
        }

        if (requestParameters.statementOptions) {
            queryParameters['StatementOptions'] = requestParameters.statementOptions;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/1.0/reporting/download-pdf-statement`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download a PDF for a specified report
     */
    async clientDetailsGetPdfStatementDownload(requestParameters: ClientDetailsGetPdfStatementDownloadRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.clientDetailsGetPdfStatementDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a clients portfolio summary
     */
    async clientDetailsGetPortfolioSummaryRaw(requestParameters: ClientDetailsGetPortfolioSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfPortfolioSummaryViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        if (requestParameters.effectiveDate !== undefined) {
            queryParameters['effectiveDate'] = (requestParameters.effectiveDate as any).toISOString();
        }

        if (requestParameters.includeAll !== undefined) {
            queryParameters['includeAll'] = requestParameters.includeAll;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/1.0/reporting/portfolio-summary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfPortfolioSummaryViewModelFromJSON(jsonValue));
    }

    /**
     * Get a clients portfolio summary
     */
    async clientDetailsGetPortfolioSummary(requestParameters: ClientDetailsGetPortfolioSummaryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfPortfolioSummaryViewModel> {
        const response = await this.clientDetailsGetPortfolioSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get client plan details
     */
    async clientDetailsSearchClientPlanDetailsRaw(requestParameters: ClientDetailsSearchClientPlanDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfIntermediaryClientPlanDetail>> {
        if (requestParameters.request === null || requestParameters.request === undefined) {
            throw new runtime.RequiredError('request','Required parameter requestParameters.request was null or undefined when calling clientDetailsSearchClientPlanDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/1.0/reporting/client-plan-details`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IntermediaryClientPlanDetailsRequestToJSON(requestParameters.request),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfIntermediaryClientPlanDetailFromJSON(jsonValue));
    }

    /**
     * get client plan details
     */
    async clientDetailsSearchClientPlanDetails(requestParameters: ClientDetailsSearchClientPlanDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfIntermediaryClientPlanDetail> {
        const response = await this.clientDetailsSearchClientPlanDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ClientDetailsGetExcelStatementDownloadStatementTypeEnum = {
    TransactionDetail: 'TransactionDetail',
    TransactionSummary: 'TransactionSummary',
    FundDetail: 'FundDetail',
    InternalRateOfReturn: 'InternalRateOfReturn',
    EffectiveAnnualCost: 'EffectiveAnnualCost',
    AnnuityDetail: 'AnnuityDetail'
} as const;
export type ClientDetailsGetExcelStatementDownloadStatementTypeEnum = typeof ClientDetailsGetExcelStatementDownloadStatementTypeEnum[keyof typeof ClientDetailsGetExcelStatementDownloadStatementTypeEnum];
/**
 * @export
 */
export const ClientDetailsGetPdfStatementDownloadStatementTypeEnum = {
    TransactionDetail: 'TransactionDetail',
    TransactionSummary: 'TransactionSummary',
    FundDetail: 'FundDetail',
    InternalRateOfReturn: 'InternalRateOfReturn',
    EffectiveAnnualCost: 'EffectiveAnnualCost',
    AnnuityDetail: 'AnnuityDetail'
} as const;
export type ClientDetailsGetPdfStatementDownloadStatementTypeEnum = typeof ClientDetailsGetPdfStatementDownloadStatementTypeEnum[keyof typeof ClientDetailsGetPdfStatementDownloadStatementTypeEnum];
